/// <reference path="../../../../state/rdms/types.js" />
import { useSelector } from "react-redux";
import { truncate } from "../../../../utils/string.utils";
import { RelatedUsers } from "../RelatedUsers";
import { TippyRelatedUsers } from "../RelatedUsers/TippyRelatedUsers";
import { TrashButton } from "../TrashButton";
import {
  RdmContainer,
  RdmGridContent,
  RdmDescription,
  RdmHeader,
  RdmGridItem,
} from "./styles";
import { DateTime } from "luxon";
import { ProtectedComponent } from "../../../../components/general/Protected";
import { useCallback } from "react";

/**
 * @param {RdmUser[] } rdmUsers
 * @returns {{ positives: number, negatives: number, total: number }}
 */
const getRdmFeedBack = (rdmUsers) => {
  const positives = rdmUsers.reduce((acc, user) => acc + user.positives, 0);
  const negatives = rdmUsers.reduce((acc, user) => acc + user.negatives, 0);
  return { positives, negatives, total: positives + negatives };
};

/**
 * @param {{ rdm: Rdm, onClick: () => void, onRemove: (rdm: Rdm) => void }} props
 */
export function RDMItem({ rdm, onClick, onRemove }) {
  const { positives, negatives } = getRdmFeedBack(rdm.rdmUsers);
  // @ts-ignore
  const { user } = useSelector((state) => state.auth);

  const getPercentPositives = useCallback(() => {
    if (positives && negatives) {
      const total = positives + negatives;
      return ((positives / total) * 100).toFixed(2);
    }
    return 0;
  }, [negatives, positives]);

  const handleRemove = () => {
    onRemove(rdm);
  };

  return (
    <RdmContainer onClick={onClick}>
      <RdmHeader>
        <p>{rdm.title}</p>
        <ProtectedComponent rank={user.rank} allowed={["gerente", "admin"]}>
          <TrashButton onClick={handleRemove} />
        </ProtectedComponent>
      </RdmHeader>
      <RdmDescription>
        <p>{truncate(rdm.description, 250)}</p>
      </RdmDescription>
      <RdmGridContent>
        <RdmGridItem>
          <span className="rdm-item-header">Data de criação</span>
          <span className="rdm-item-content">
            {DateTime.fromISO(rdm.createdAt).toFormat("dd/MM/yyyy")}
          </span>
        </RdmGridItem>
        <RdmGridItem>
          <span className="rdm-item-header">Última atualização</span>
          <span className="rdm-item-content">
            {DateTime.fromISO(rdm.updatedAt).toFormat("dd/MM/yyyy")}
          </span>
        </RdmGridItem>
        <RdmGridItem>
          <span className="rdm-item-header">Efetividade</span>
          <span className="rdm-item-content percents">{`${getPercentPositives()}%`}</span>
        </RdmGridItem>
        <RdmGridItem>
          <span className="rdm-item-header">Positivos</span>
          <span className="rdm-item-content positives">{`${positives}`}</span>
        </RdmGridItem>
        <RdmGridItem>
          <span className="rdm-item-header">Negativos</span>
          <span className="rdm-item-content negatives">{`${negatives}`}</span>
        </RdmGridItem>
        <RdmGridItem>
          <span className="rdm-item-header">Usuários Relacionados</span>
          <div className="rdm-item-content">
            <TippyRelatedUsers users={rdm.rdmUsers}>
              <RelatedUsers users={rdm.rdmUsers} />
            </TippyRelatedUsers>
          </div>
        </RdmGridItem>
      </RdmGridContent>
    </RdmContainer>
  );
}
